import { createApp } from '@backstage/frontend-defaults';
// Plugins de frontend (nuevo system): se registran explícitamente vía /alpha.
// (app.packages: all no registra sus APIs de forma fiable en este scaffold.)
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
// Plugin comunitario de Grafana (new frontend system): registra api:grafana y las
// entity-card:grafana/{dashboards,alerts,overview-dashboard}, que se autofiltran por
// las annotations grafana/* de cada entidad del catálogo.
import grafanaPlugin from '@backstage-community/plugin-grafana/alpha';
import { navModule } from './modules/nav';
import { authModule } from './modules/auth';
import { sabanaModule } from './modules/sabana';
import { observabilityModule } from './modules/observability';
import { servicesModule } from './modules/services';
import { s3MaintenanceModule } from './modules/s3-maintenance';
import { discordModule } from './modules/discord';
import { discordReportsModule } from './modules/discordReports';

export default createApp({
  features: [
    catalogPlugin,
    apiDocsPlugin,
    catalogGraphPlugin,
    catalogImportPlugin,
    kubernetesPlugin,
    notificationsPlugin,
    orgPlugin,
    scaffolderPlugin,
    searchPlugin,
    signalsPlugin,
    techdocsPlugin,
    userSettingsPlugin,
    grafanaPlugin,
    navModule,
    authModule,
    sabanaModule,
    observabilityModule,
    servicesModule,
    s3MaintenanceModule,
    discordModule,
    discordReportsModule,
  ],
});
